import React, { useEffect, useState, useMemo, forwardRef, useCallback } from 'react';
import { find } from 'lodash';
import { Form } from 'antd'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const AppknoxMappingForm = forwardRef(({disableProjectFields = false, ...props}, ref) => {
  const [projectList, setProjectList] = useState({})
  const [organisationList, setOrganisationList] = useState([]);
  const [organisation,setOrganisation] = useState("");
  const [form] = Form.useForm();

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setOrganisationList(projects);
    }).catch(() => {
      message.error('Problem fetching projects')
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);


  const fetchProjects =  useCallback((organisation) =>{
    if(!projectList[organisation] && organisation){
        const {promise,cancel} = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, 
        { login_id: props.loginConfigId, organisation});

        promise.then(response=>{
          const { projects } = response;
          setProjectList((projectList) =>({...projectList,[organisation]:projects}));
        }).catch(()=>{
        message.error('Problem fetching projects')
        })

        return cancel;
      }
  },[props.loginConfigId,props.toolName,projectList])

  useEffect(()=>{
    return fetchProjects(organisation);
  },[organisation,fetchProjects])

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
        const { orgId} = config;
        setOrganisation(orgId)
    }, []);

  const onOrganisationChange = useCallback((value, field) => {
    setOrganisation(value)
    const { name } = field;
    const configurations = form.getFieldValue("configurations");
    configurations[name] = {
      ...configurations[name],
      projectId: undefined
    }
    form.setFieldsValue({ configurations: configurations });
  }, [form]);

  const getExtraFieldsData = (config) => {
    const { projectId, orgId } = config;
    const {name,otherProperties:{platform}} = find(projectList[orgId], project => projectId === project.id)
    
    return ({
      projectId, orgId,platform,
      package:name,
      orgName: organisationList.find(org => org.id === orgId)?.name,
    });
  };

  const isProjectFieldDisabled = useCallback((fieldKey, form) => {
    const fieldConfiguration = form.getFieldValue("configurations")[fieldKey];
    return (!fieldConfiguration || !fieldConfiguration.orgId);
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'orgId',
      colSpan: '10',
      type: FieldTypes.SELECT,
      label: 'Organization',
      options: parseSelectOptions(organisationList),
      disabled: disableProjectFields,
      required: true,
      props: {
        onChange: onOrganisationChange,
        autoFocus: !disableProjectFields
      }
    },
    {
      name: 'projectId',
      colSpan: '13',
      type: FieldTypes.SELECT,
      label: 'Appknox Package',
      propsGenerator: (fieldKey) => ({ disabled: isProjectFieldDisabled(fieldKey, form) || disableProjectFields }),
      options:parseSelectOptions(projectList[organisation]),
      required: true,
      loading:!projectList[organisation]
    }
  ]), [organisation,form, onOrganisationChange, organisationList, isProjectFieldDisabled, disableProjectFields,projectList]);

  
  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default AppknoxMappingForm;
